import React, { useState, forwardRef } from "react"
import { PLACEHOLDER_ICONS } from "../../constants/placeholders"

const Img = forwardRef(function Img(
  {
    src,
    alt = "",
    type = "default",
    className = "",
    objectFit,
    ...rest
  },
  ref
) {

  const [hasError, setHasError] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const Icon =
    PLACEHOLDER_ICONS[type] ||
    PLACEHOLDER_ICONS.default

  ////////////////////////////////////////////////////
  // SHOW ICON IF NO IMAGE
  ////////////////////////////////////////////////////

  if (!src || hasError) {

    return (
      <div className={`flex items-center justify-center bg-gray-100 ${className}`}>

        <Icon className="text-gray-400 text-5xl" />

      </div>
    )
  }

  ////////////////////////////////////////////////////
  // NORMAL IMAGE
  ////////////////////////////////////////////////////

  return (

    <div className="relative">

      <img
        ref={ref}
        src={src}
        alt={alt}
        draggable={false}
        onLoad={() => setLoaded(true)}
        onError={() => setHasError(true)}
        className={`transition-opacity duration-200 ${className}`}
        style={{
          opacity: loaded ? 1 : 0,
          ...(objectFit ? { objectFit } : {})
        }}
        {...rest}
      />

    </div>

  )

})

export default Img